export function parseJsonError(error, modulo) {
  var noti = {};
  var obj = JSON.parse(JSON.stringify(error));
  var graph = obj.graphQLErrors[0];
  if (graph == null) {
    window.console.error('ERROR INESPERADO:::', obj);
    noti = { group: 'auth', title: 'Error Desconocido', text: 'Intente actualizar la pagina.' };
    return noti;
  }
  var mensaje = graph.message;
  if (mensaje.statusCode == 403) {
    if (modulo == null) modulo = '';
    else modulo = ' :' + modulo;
    noti = {
      group: 'auth',
      type: 'error',
      title: 'Acceso Denegado',
      text: 'No tiene permiso para realizar esta accion. ' + modulo,
      duration: 10000,
    };
  } else {
    var men = '';
    if (mensaje.message) men += mensaje.message;
    if (mensaje.error) men += ' - ' + mensaje.error;
    noti = { group: 'auth', title: 'Se ha producido un error', text: men };
  }
  return noti;
}

export function datFaltantes(error) {
  var noti = { group: 'auth', type: 'error', title: 'Datos faltantes', text: error, duration: 8000 };
  return noti;
}

export function error(title, subtitle) {
  var noti = { group: 'auth', type: 'error', title: title, text: subtitle, duration: 10000 };
  return noti;
}

export function errorPago(title) {
  var noti = {
    group: 'auth2',
    type: 'info',
    title: title,
    text: 'Asegurese de haber pagado la matricula',
    duration: 10000,
  };
  return noti;
}

export function exito(title, subtitle) {
  var noti = { group: 'auth3', type: 'success', title: title, text: subtitle, duration: 10000 };
  return noti;
}

export function exito2(title, subtitle, duracion) {
  var noti = { group: 'auth4', type: 'success', title: title, text: subtitle, duration: duracion };
  return noti;
}

export function error2(title, subtitle, duracion) {
  var noti = { group: 'auth4', type: 'error', title: title, text: subtitle, duration: duracion };
  return noti;
}

export function isNullObject(obj) {
  if (obj == null || obj == undefined || window.Object.entries(obj).length === 0) return true;
  return false;
}

export function strFechaBusqueda(busquedaObject) {
  if (busquedaObject == null) return 'null';
  if (busquedaObject.fecha_ini == null) return 'null';
  if (busquedaObject.fecha_fin == null) return 'null';
  var parts1 = busquedaObject.fecha_ini.split('-');
  var parts2 = busquedaObject.fecha_fin.split('-');
  var a1 = parts1[0];
  var m1 = parts1[1];
  var d1 = parts1[2];
  var a2 = parts2[0];
  var m2 = parts2[1];
  var d2 = parts2[2];
  return d1 + '/' + m1 + '/' + a1 + ' al ' + d2 + '/' + m2 + '/' + a2;
}

export function getCleanedString(cadena) {
  //window.console.log( ">>>>CNAITTTTT ",cadena )
  // Definimos los caracteres que queremos eliminar
  var specialChars = '!@#$^&%*()+=-[]\\/{}|:<>?,.';

  // Los eliminamos todos
  for (var i = 0; i < specialChars.length; i++) {
    cadena = cadena.replace(new RegExp('\\' + specialChars[i], 'gi'), '');
  }

  // Lo queremos devolver limpio en minusculas
  cadena = cadena.toLowerCase();

  // Quitamos espacios y los sustituimos por _ porque nos gusta mas asi
  cadena = cadena.replace(/ /g, '_');

  // Quitamos acentos y "ñ". Fijate en que va sin comillas el primer parametro
  cadena = cadena.replace(/á/gi, 'a');
  cadena = cadena.replace(/é/gi, 'e');
  cadena = cadena.replace(/í/gi, 'i');
  cadena = cadena.replace(/ó/gi, 'o');
  cadena = cadena.replace(/ú/gi, 'u');
  cadena = cadena.replace(/ñ/gi, 'n');
  //window.console.log( ">>>>CNAITTTTT ",cadena )
  return cadena;
}

// the input(estado) must be of type number (integer)
export function parseProgramaModuloEstado(estado) {
  // if (estado === 1) return 'NO PROGRAMADO';
  // if (estado === 2) return 'PROGRAMADO';
  // if (estado === 3) return 'POSTERGADO';
  // if (estado === 4) return 'CONCLUIDO';
  // //  default 0
  // return 'UNKNOWN';
  if (estado === 0) return 'INSCRIPCION';
  if (estado === 1) return 'PROGRAMADO';
  if (estado === 2) return 'EN DESARROLLO';
  if (estado === 3) return 'POSTERGADO';
  if (estado === 4) return 'CONCLUIDO';
  //  default 0
  return 'UNKNOWN';
}

// the input(estado) must be of type number (integer)
export function parseInscripcionEstado(estado) {
  // if (estado === 1) return 'INSCRITO';
  // if (estado === 2) return 'INSCRITO CERTIFICACION';
  // if (estado === 3) return 'RETIRADO';
  // if (estado === 4) return 'CAMBIADO';
  // if (estado === 5) return 'CONGELADO';
  // if (estado === 6) return 'PAGO INSCRIPCION';
  // if (estado === 7) return 'PAGADO';
  // if (estado === 8) return 'POR CIERRE';
  // if (estado === 9) return 'POR CAMBIO';
  // if (estado === 10) return 'POR GENERAR PLAN PAGOS';
  // // default 0
  // return 'PREINSCRITO';

  if (estado === 1) return 'PREINSCRITO';
  if (estado === 2) return 'INSCRITO';
  if (estado === 4) return 'CONGELADO';
  if (estado === 8) return 'INCORPORADO';
  if (estado === 16) return 'REINSCORPORADO';
  if (estado === 32) return 'RETIR0 VOLUNTARIO';
  if (estado === 64) return 'RETIR0 INVOLUNTARIO';
  // // default 0
  return 'SIN ESTADO';
}

// the input(estado) must be of type number (integer)
export function parseInscripcionModuloEstado(student) {
  // student.nota_final,  // aprovado || reprobado
  // student.nota_recuperatorio, // aprovado || reprobado

  if (student.estado === 2) return 'RETIR0 VOLUNTARIO'; // congelado
  if (student.estado === 1) return 'RETIR0 INVOLUNTARIO'; // retirado

  if (student.tipo_ingreso === 1) return 'REINSCORPORADO';
  if (student.tipo_ingreso === 0) return 'INSCRITO';
  // if (estado === 16) return 'REINSCORPORADO';
  // // default 0
  return 'ACTIVO';
}

// the input(estado) must be of type number (integer)
export function parseEstadoPrograma(estado) {
  if (estado === 1) return 'INSCRIPCION';
  if (estado === 2) return 'DESARROLLO';
  if (estado === 3) return 'CONCLUIDO';
  if (estado === 4) return 'ELABORACION TRABAJOS FINALES';
  if (estado === 5) return 'RECEPCION DE REQUISITOS DE TITULACION';
  if (estado === 6) return 'ARMADO CARPETAS';
  if (estado === 7) return 'PAGO ARANCELES';
  if (estado === 8) return 'PROCESO TITULACION';
  if (estado === 9) return 'CERTIFICADOS ENTREGADOS';
  // default 0
  return 'PREINSCRIPCION';
}

// the input(estado) must be of type number (integer)
export function parseStatusPosgrado(estado) {
  if (estado === 1) return 'APROBADO';
  if (estado === 2) return 'PERMITIR CREAR PROGRAMA';
  // default 0
  return 'POR APROBAR';
}

// the input(estado) must be of type number (integer)
export function parseEstadoRecibo(estado) {
  if (estado === 1) return 'ACTIVO';
  if (estado === 2) return 'AMBOS';
  // default 0
  return 'INACTIVO';
}

// the input(estado) must be of type number (integer)
export function parseUnidadDuracion(estado) {
  if (estado === 1) return 'AÑ0';
  if (estado === 2) return 'DIA';
  if (estado === 3) return 'HORA';
  // default 0
  return 'MES';
}

// the input(estado) must be of type number (integer)
export function parseTipoPago(estado) {
  if (estado === 1) return 'CUOTAS';
  if (estado === 2) return 'CONTADO';
  // default 0
  return 'SIN ESTADO';
}
export function parseModalidad(text) {
  if (text === 'SEMIPRESENCIAL') return 'S';
  if (text === 'PRESENCIAL') return 'P';
  return 'V';
}

export function parseModalidadInverse(mod) {
  if (mod == 'S') return 'Semipresencial';
  else if (mod == 'P') return 'Presencial';
  else if (mod == 'V') return 'Virtual';
  else return mod;
}

export function parseFasePrograma(fase) {
  if (fase == 0) return 'No aprobado';
  if (fase == 1) return 'Inscripciones';
  else if (fase == 2) return 'En Desarrollo';
  else if (fase == 3) return 'En Tramite';
  else if (fase == 4) return 'Cerrado';
  return fase;
}

export function parseDateWithMiddleDash(date = Date.now()) {
  let dd = String(date.getDate()).padStart(2, '0');
  let mm = String(date.getMonth() + 1).padStart(2, '0');
  let yyyy = date.getFullYear();
  date = dd + '-' + mm + '-' + yyyy;
  return date;
}
export function parseDateWithSlash(date) {
  let dd = String(date.getDate()).padStart(2, '0');
  let mm = String(date.getMonth() + 1).padStart(2, '0');
  let yyyy = date.getFullYear();
  date = dd + '/' + mm + '/' + yyyy;
  return date;
}
export function crearUserNameMoodle(estudiante) {
  let username = '';
  let nombres = estudiante.nombres;
  let pri_apellido = estudiante.pri_apellido;
  let seg_apellido = estudiante.seg_apellido;
  nombres && nombres.length > 0 ? (username = nombres.substring(0, 1)) : null;
  pri_apellido ? (username = username + pri_apellido.replace(/\s+/g, '')) : null;
  seg_apellido ? (username = username + seg_apellido.replace(/\s+/g, '')) : null;
  estudiante.usuario_moodle = username ? getCleanedString(username) : null;
  return estudiante.usuario_moodle;
}
export function crearClaveMoodle(estudiante) {
  let password_moodle = '';
  estudiante.num_doc && estudiante.num_doc.length > 0 ? (password_moodle = estudiante.num_doc) : null;
  estudiante.departamento ? (password_moodle = password_moodle + estudiante.departamento.extension) : null;
  return password_moodle;
}

export function generarCodigoPersona(fechaStr, nombres, apellido1, apellido2) {
  const fecha = fechaStr || '';
  const partesFecha = fecha.split('-');
  const fechaFormateada =
    partesFecha.length === 3 ? `${partesFecha[2]}-${partesFecha[1]}-${partesFecha[0]}` : fecha;

  nombres = getCleanedString(nombres || '');
  apellido1 = getCleanedString(apellido1 || '');
  apellido2 = getCleanedString(apellido2 || '');

  const simbolos = ['$', '*'];
  const inicialesNombres = (nombres || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((nombre) => nombre.charAt(0).toUpperCase())
    .join('');
  const inicialesApellidos = [apellido1, apellido2]
    .filter((apellido) => apellido && apellido.trim())
    .map((apellido) => apellido.trim().charAt(0).toLowerCase())
    .join('');
  const simboloAleatorio = simbolos[Math.floor(Math.random() * simbolos.length)];

  return `${fechaFormateada}-${inicialesNombres}${inicialesApellidos}${simboloAleatorio}`;
}

export function simpleValues(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key] === null) {
      delete obj[key];
    }
  }
  return obj;
}

/* export function generarCodigoPersona(fechaStr, nombres, apellido1, apellido2) {
  const fecha = fechaStr || '';
  const partesFecha = fecha.split('-');
  const fechaFormateada =
    partesFecha.length === 3 ? `${partesFecha[2]}-${partesFecha[1]}-${partesFecha[0]}` : fecha;

  nombres = getCleanedString(nombres || '');
  apellido1 = getCleanedString(apellido1 || '');
  apellido2 = getCleanedString(apellido2 || '');

  const simbolos = ['$', '*'];
  const inicialesNombres = (nombres || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((nombre) => nombre.charAt(0).toUpperCase())
    .join('');
  const inicialesApellidos = [apellido1, apellido2]
    .filter((apellido) => apellido && apellido.trim())
    .map((apellido) => apellido.trim().charAt(0).toLowerCase())
    .join('');
  const simboloAleatorio = simbolos[Math.floor(Math.random() * simbolos.length)];

  return `${fechaFormateada}-${inicialesNombres}${inicialesApellidos}${simboloAleatorio}`;
} */

// the input(estado) must be of type number (integer)
export function parseUnidadNegocio(name) {
  if (name === 'ESAM') return 1;
  if (name === 'CCA') return 2;
  if (name === 'CIBERKIDS') return 3;
  if (name === 'CAS') return 4;
  if (name === 'ESAM_LATAM') return 5;
  if (name === 'CYBERCORP') return 6;
  if (name === 'FORMACION_CONTINUA') return 7;
  if (name === 'INTRADIGITAL') return 8;
  if (name === 'DIGITAL_ACADEMY') return 9;
  // default 0
  return 0;
}
export function parseUnidadDuracion2(u) {
  if (u == 0) return 'meses';
  else if (u == 1) return 'semanas';
  else if (u == 2) return 'dias';
  else if (u == 3) return 'horas';
}

export function parseColorcito(fase) {
  if (fase == 0) return 'rojito';
  else if (fase == 1) return 'naranja';
  else if (fase == 2) return 'verde';
  else return 'marron';
}

export function getheadersrest() {
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  let s = window.localStorage.getItem('TOKEN');
  let decryptedBytes = window.CryptoJS.AES.decrypt(s, 'estanoesunaclavesecreta');
  let plaintext = decryptedBytes.toString(window.CryptoJS.enc.Utf8);
  let accessToken = plaintext;
  myHeaders.append('Authorization', accessToken);
  // window.console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>.\n',accessToken);
  return myHeaders;
}

export function gettokenheaderrest() {
  let s = window.localStorage.getItem('TOKEN');
  let decryptedBytes = window.CryptoJS.AES.decrypt(s, 'estanoesunaclavesecreta');
  let plaintext = decryptedBytes.toString(window.CryptoJS.enc.Utf8);
  let accessToken = plaintext;
  return { Authorization: accessToken };
  //return {};
}
export function formatDate(date) {
  if (!date) return null;
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
}
export function formatCodeProgram(program) {
  return `${program.nombre_compuesto.slice(0, 1)}-${program.id}`;
}

export function myFunction1(filtro, table) {
  filtro = filtro.toUpperCase();
  var tr, tdd, td, i, j, txtValue;
  //table = document.getElementById("midatatablexx");
  tr = table.getElementsByTagName('tr');

  for (i = 0; i < tr.length; i++) {
    tdd = tr[i].getElementsByTagName('td');
    for (j = 1; j < tdd.length; j++) {
      td = tdd[j];
      if (td) {
        txtValue = td.textContent;
        if (txtValue.toUpperCase().indexOf(filtro) > -1) {
          tr[i].style.display = '';
          break;
        } else {
          tr[i].style.display = 'none';
        }
      }
    }
  }
}
